import axios from "axios";
const jsonConfig = require("../../Config.json");

const jobDescription = async (payload, isUpdate = false) => {
  try {
    const method = isUpdate ? 'put' : 'post';
    const response = await axios[method](
      jsonConfig.apiUrl + "jobDescription",
      payload,
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );
    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
};

export default jobDescription;